import styles from './CheckMark.module.scss';

/**
 * The tick lifted from the prototype, so its shape and fill match everywhere it appears. Shared with
 * `MergedSuccess`'s capability list rather than redrawn per screen.
 */
export function CheckMark({ size = 13 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" aria-hidden="true">
      <path d="M17 5.4 15.6 4 7.9 12.7 3.4 8.5 2 9.9l6 5.6L17 5.4Z" fill="#2CB355" />
    </svg>
  );
}

/** The tick on a pale green disc, for benefit lists. */
export function CircledCheck() {
  return (
    <span className={styles.circled}>
      <CheckMark />
    </span>
  );
}
